import React, { ReactNode } from 'react';

const StickyHeader = ({ children }: { children: ReactNode }) => {
  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 20 }}>{children}</div>
  );
};

export default StickyHeader;
